import { Minus, Plus, Scissors, Trash2 } from 'lucide-react';
import MySearchableSelect from '../../components/MyComponent/BillingSearchableSelect';
import { useDispatch, useSelector } from 'react-redux';
import { searchSalonChild, searchStaff, searchUser } from '../../constant/Constant';
import { setServicesJson } from '../../redux/Actions/BillingAction';
import MyInput from '../../components/MyComponent/MyInput';
import { setDataAction } from '../../redux/Actions/SetDataAction';
import { calculateBillSummary } from '../../utils/utils';
import { SET_SERVICE_INFO } from '../../redux/ActionName/ActionName';

export const ServiceSection = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer)
    const dispatch = useDispatch();
    const handelServiceChange = (type, value, index) => {
        let oldData = [...BillingReducer?.selectedServices];
        if (type === 'removeService') {
            oldData = [...oldData.slice(0, index), ...oldData.slice(index + 1)]
        }
        else {
            if (type === "selectService") {
                const quantity = oldData[index]?.quantity || 1;
                oldData[index] = { ...oldData[index], serviceData: value, price: value.price, total: value.price * quantity, };
            }
            else if (type === 'changeQty') {
                oldData[index] = { ...oldData[index], quantity: value };
            }
            else if (type === 'changeStaff') {
                oldData[index] = { ...oldData[index], staffData: value };
            }
            else if (type === 'changePrice') {
                if (value !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(value)) return;
                oldData[index] = { ...oldData[index], price: value };
            }
            // Total calculate kar
            const price = oldData[index].price
            const qty = oldData[index].quantity || 1;
            oldData[index] = { ...oldData[index], total: price * qty };
        }
        dispatch(setDataAction(oldData, SET_SERVICE_INFO));
        const updatedBillingReducer = { ...BillingReducer, selectedServices: oldData };
        calculateBillSummary(updatedBillingReducer, dispatch);
    };
    console.log(" BillingReducer?.selectedServices-----", BillingReducer);


    console.log("BillingReducer", BillingReducer);

    return (
        <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="flex items-center gap-2 mb-4">
                <Scissors className="text-gray-800" size={20} />
                <h2 className="text-xl font-semibold text-gray-800">Select Services</h2>
            </div>
            {
                BillingReducer?.selectedServices?.length === 0 ?
                    <div className="text-center py-8 text-gray-500">
                        <Scissors className="mx-auto mb-2" size={24} />
                        <p>No services added yet. Click "Add Service" to get started.</p>
                    </div>
                    :

                    BillingReducer?.selectedServices?.map((service, index) => {
                        console.log('service', service);

                        return (
                            <div key={service.id} className="grid grid-cols-5 gap-4 mb-4 items-end">
                                <div>
                                    <MySearchableSelect onChange={(value) => handelServiceChange("selectService", value, index)} value={service?.serviceData?.name} giveFullElement={true} api={searchSalonChild} optionLable="name" title="Search Service" placeholder={"Select Service"} />
                                </div>
                                <div>
                                    <MySearchableSelect onChange={(value) => handelServiceChange('changeStaff', value, index)} value={service?.staffData?.name} giveFullElement={true} api={searchUser} optionLable="name" title="Search Staff" placeholder={"Select Service"} />
                                </div>
                                <div>
                                    <MyInput onChange={(e) => handelServiceChange('changePrice', e.target.value, index)} title={'Price'} value={service?.price || ""} />
                                </div>
                                <div>
                                    <div className="flex items-center">
                                        <button
                                            type="button"
                                            onClick={() => handelServiceChange('changeQty', BillingReducer?.selectedServices[index]?.quantity === 1 ? 1 : BillingReducer?.selectedServices[index]?.quantity - 1, index)}
                                            className="p-2 bg-gray-200 mt-8  rounded-l-lg hover:bg-gray-300"
                                        >
                                            <Minus size={16} />
                                        </button>
                                        <MyInput title={"quantity"} value={service.quantity ? service.quantity : 1} onClick={(e) => handelServiceChange('changeQty', e.target.value, index)} />
                                        <button
                                            type="button"
                                            onClick={() => handelServiceChange('changeQty', BillingReducer?.selectedServices[index]?.quantity + 1, index)}
                                            className="p-2 bg-gray-200 mt-8 rounded-r-lg hover:bg-gray-300"
                                        >
                                            <Plus size={16} />
                                        </button>
                                    </div>
                                </div>

                                <div className="flex items-center gap-2">
                                    <span className="text-lg font-semibold text-gray-800">₹{service.total}</span>
                                    <button
                                        onClick={() => handelServiceChange("removeService", false, index)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        <Trash2 size={16} />
                                    </button>
                                </div>
                            </div>
                        )
                    })

            }
        </div>
    )
}



